var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export default styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* Allow translate to expand somewhere + don't cut shadows */\n  margin-top: ", "; \n  margin-bottom: ", ";\n  text-align: left;\n  transition: transform .24s, box-shadow .24s;\n  border-radius: 3px;\n  ", "\n"], ["\n  /* Allow translate to expand somewhere + don't cut shadows */\n  margin-top: ", "; \n  margin-bottom: ", ";\n  text-align: left;\n  transition: transform .24s, box-shadow .24s;\n  border-radius: 3px;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.two;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.two;
}, function (_a) {
    var theme = _a.theme;
    return theme.animations.hover;
});
var templateObject_1;
